import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Toaster 
        position="top-right"
        toastOptions={{
          success: {
            style: {
              background: '#0b8e36', // Vert de la charte graphique
              color: 'white',
            },
            iconTheme: {
              primary: 'white',
              secondary: '#0b8e36',
            },
          },
          error: {
            style: {
              background: '#ef4444', // Rouge pour les erreurs
              color: 'white',
            },
            iconTheme: {
              primary: 'white',
              secondary: '#ef4444',
            },
          },
          loading: {
            style: {
              background: '#e88c00', // Orange de la charte graphique
              color: 'white',
            },
          },
        }}
      />
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
